import React from 'react'
import { Globe } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage()

  const toggleLanguage = () => {
    setLanguage(language === 'zh' ? 'en' : 'zh')
  }

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-1 px-3 py-2 rounded-lg text-gray-600 hover:text-primary-600 hover:bg-gray-100 transition-colors text-sm font-medium"
      aria-label="Switch Language"
    >
      <Globe size={16} />
      <span>{language === 'zh' ? 'EN' : '中文'}</span>
    </button>
  )
}

export default LanguageSwitcher 